import { AlertStatus, AssignmentStatus } from 'core/constants';
import { MonitoringStats, PaginatedResponse, TagResponse, UserNameGenderResponse, UuidableName } from 'utils/api/types';

import { UserNameResponse, UserResponse } from 'utils/api/modules/user/user.types';

import ListDevice from 'stores/DeviceList/ListDevice';
import { ActivityResponse as VatixActivityResponse } from 'ui/types';

export interface LocationResponse extends LocationCoordinateResponse {
  address: string;
  valid: boolean;
}

export interface LocationCoordinateResponse {
  uuid: string;
  lng: string;
  lat: string;
}

export interface LocationHistoryResponse extends LocationCoordinateResponse {
  alertsStatus: AlertStatus;
  address: string;
}

export interface LocationAddressResponse {
  uuid: string;
  address: string;
  lat: string;
  lng: string;
}

export interface DeviceDetailsResponse {
  uuid: string;
  type: DeviceTypeResponse;
  customId: string;
  user: UserNameResponse | null;
  knownUser: boolean;
  lastPoll: string | null;
  lastLocation: LocationAddressResponse | null;
  tags: TagResponse[];
  groups: UuidableName[];
  costCentre: string | null;
}

export interface DeviceUpdateData {
  user?: string | null;
  tags?: { name: string }[];
  groups?: string[];
  costCentre?: string | null;
}

export interface DeviceTypeResponse {
  uuid: string;
  brand: string;
  model: string;
  image: string;
}

export interface SharedDeviceWithTypeResponse {
  uuid: string;
  type: DeviceTypeResponse;
  customId: string;
}

export interface DeviceListResponse extends SharedDeviceWithTypeResponse {
  user: UserResponse | null;
  tags: TagResponse[];
  groups: UuidableName[];
}

export type DeviceListPaginatedResponse = PaginatedResponse<ListDevice> & {
  stats: MonitoringStats;
};

export type DeviceAnalyticsType = {
  date: string;
  active: number;
  inactive: number;
};

export enum DeviceType {
  MobileApp = 'mobile_app',
  SharedDevice = 'shared_device',
}

export interface DeviceResponse {
  uuid: string;
  phoneNumber: string;
  imei?: string;
  customId?: string;
  type?: DeviceTypeResponse;
  deviceType: DeviceType;
  tags: TagResponse[];
}

export interface SharedDeviceResponse extends DeviceResponse {
  imei: string;
  customId: string;
}

export interface DevicesSearchResponse extends UuidableName {
  // name is custom_id, but field is renamed to keep compalibility with UuidableName type
  brand: string;
  model: string;
  image: string;
  user: string | null;
}

export interface DeviceAssignmentResponse {
  uuid: string;
  user: UserNameResponse;
  assigned: string;
  unassigned: string | null;
}

export type DeviceHistoryPaginatedResponse = PaginatedResponse<DeviceAssignmentResponse>;

export interface DeviceAssignmentActivityResponse extends VatixActivityResponse {
  user: UserNameGenderResponse;
  device: DeviceResponse;
  status: AssignmentStatus;
}
